/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { OrderDetailsData, OrderDetailsService }  from './OrderDetails.service';
import { ProductsData, ProductsService } from '../Products/Products.service';
import { OrdersData, OrdersService } from '../Orders/Orders.service';


@Component({
  selector: 'OrderDetailsSearch',
  template: require('./OrderDetailsSearch.component.html'),
  providers: [OrderDetailsService
	, ProductsService, OrdersService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrderDetailsSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objOrderDetails: OrderDetailsData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	
	ProductsList: ProductsData[];
	OrdersList: OrdersData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private OrderDetailsService: OrderDetailsService
			, private  ProductsService:  ProductsService
			, private  OrdersService:  OrdersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objOrderDetails = new OrderDetailsData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objOrderDetails = new OrderDetailsData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objOrderDetails.OrderID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND OrderID = " + this.objOrderDetails.OrderID;
			else
				this.filterExpression = "OrderID = " + this.objOrderDetails.OrderID;
		}
		if (this.objOrderDetails.ProductID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ProductID = " + this.objOrderDetails.ProductID;
			else
				this.filterExpression = "ProductID = " + this.objOrderDetails.ProductID;
		}
		if (this.objOrderDetails.UnitPrice)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objOrderDetails.UnitPrice;
			else
				this.filterExpression = "UnitPrice = " + this.objOrderDetails.UnitPrice;
		}
		if (this.objOrderDetails.Quantity)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Quantity = " + this.objOrderDetails.Quantity;
			else
				this.filterExpression = "Quantity = " + this.objOrderDetails.Quantity;
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}


	// Get Lookup List for Products
    getProducts() {
		this.ProductsService.getAll().subscribe(records => this.ProductsList=records);
    }
	// Get Lookup List for Orders
    getOrders() {
		this.OrdersService.getAll().subscribe(records => this.OrdersList=records);
    }

	getLookups() {

        this.getProducts();
        this.getOrders();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetails/OrderDetailsSearch.component.ts